import { Component, ViewChild, OnInit, Output, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { Lists_nguonkinhphi, Lists_tinhchatnguonkp } from '../../../routes/menu'
import { Global, BaoCao } from '../../../shared/global';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
  selector: 'app-thamsobc-giayrutdutoanmau15edit',
  templateUrl: './giayrutdutoanmau15edit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./giayrutdutoanmau15edit.component.scss'],
  providers: [ListService, Repository]
})


export class giayrutdutoanmau15editComponent implements OnInit {


  msg: string;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  hienthikyso: boolean = false;

  doituongSelect1: any = {
  Id: null, MaDonVi: null, TenDonVi: null, DonViId: null, KTT_UserName: null
  , KTT_Password: null, CTK_UserName: null, CTK_Password: null
  , MaCapNS: null, SoTaiKhoanMoTaiKBNN: null, MaKBNN: null, dm_hs_ksc_id: null, TenVietTat: null
  , v_ma_ho_so: null, v_ma_ho_so_chi_tiet_mau: null, v_tieu_de: null
  , v_tg_ky_so_ktt: null, v_tg_ky_so_ctk: null, Phan_He_Id: null, LoaiMau: null
  , NguoiKy: null, v_tg_gui_dvc: null
  , NguoiKy_KTT: null, NguoiKy_CTK: null, v_du_lieu_toan_van: null
  , v_du_lieu_xac_thuc: null, v_chu_ky_so_ktt: null, v_chu_ky_so_ctk: null, body: null
  , Cer_ktt: null, Cer_ctk: null, hash_file: null
  , LoaiKy: null, Tich_HienChiTietCacButToan: null, Tich_TenTieuMucLaDienGiai: null
  , DoiTuong: null, Tich_HienThiTungDongChiTiet: null
    , GuiKeToanTruong: null, GuiThuTruong: null, ThongTinBoSung: null, ThamSo: null, TaiKhoan: null
};
  
  inputparents: any
  modalTitle: any;
  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, SoCKCHDK: null, SoCKCHDTH: null, PhatHanhSec: null, ThongTinBoSung: null
    , NoTK1: null, CoTK1: null, NoTK2: null, CoTK2: null, NoTK3: null, CoTK3: null
    , MaDBHC: null, DonViId: null, NoiDungThanhToan: null
    , Tich_PhatHanhSec: null, Tich_ThongTinBoSung: null, Tich_HienChiTietCacButToan:null
    , Tich_TenTieuMucLaDienGiai:null
  };
  nhomdtid: string = null;
  hoatdong: string = null;
  tabselected: number = 1;

  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @ViewChild('modaltuychinhmaubc', { static: false }) modaltuychinhmaubc: ModalComponent;
  @ViewChild('dtsuamaubaocao', { static: false }) dtsuamaubaocao: any;

  //@ViewChild('modal_dvckbnn', { static: false }) modal_dvckbnn: ModalComponent;
  //@ViewChild('dtthamdvckbnnedit', { static: false }) dtthamdvckbnnedit: any;

  @Output() save: EventEmitter<any> = new EventEmitter();



  constructor(private _dataService: ListService, private repo: Repository) {


  }

  ngOnInit(): void {

  }
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  currentUser: any;

  loadDataInit(idchungtu: any, donviid: string) {

    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {

      let data = JSON.parse(authlogin);
      this.currentUser = data;
      var giatri = data.ds_quyen.filter(name => name.id === idchungtu.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        this.modalTitle = giatri[0].ten_Phan_He;
        if (giatri[0].them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }


      //if (this.currentUser.user_name = 'system') {
        this.hienthikyso = true;
      //}

    }

    setTimeout(() => {
      this.mafocus.nativeElement.focus();
    }, 500);
    //this.repo.getRequest("api/doituong/getall2/" + nhomdoituongid + '/null/' + donviid)
    //  .subscribe(response => {
    //    this.inputparents = response;
    //  });
    this.doituongSelect = {
      Id: null, SoCKCHDK: null, SoCKCHDTH: null, PhatHanhSec: null, ThongTinBoSung: null
      , NoTK1: null, CoTK1: null, NoTK2: null, CoTK2: null, NoTK3: null, CoTK3: null
      , MaDBHC: null, DonViId: null, NoiDungThanhToan: null
      , Tich_PhatHanhSec: null, Tich_ThongTinBoSung: null, Tich_HienChiTietCacButToan: null, Tich_TenTieuMucLaDienGiai: null
    };
    this.doituongSelect.Id = idchungtu;
    this.doituongSelect.Tich_PhatHanhSec = false;
    this.doituongSelect.PhatHanhSec = 'Yêu cầu phát hành sec cho';
    this.doituongSelect.Tich_ThongTinBoSung = false;
    this.doituongSelect.DonViId = donviid;
    this.doituongSelect.Tich_HienChiTietCacButToan = true;
    this.doituongSelect.Tich_TenTieuMucLaDienGiai = false;


     
    this.doituongSelect1.Id = idchungtu;
    this.doituongSelect1.DonViId = donviid;
    this.doituongSelect1.LoaiMau = 115;
    this.repo.postRequest("api/dvcapi/getbyid_dvc_thamso", this.doituongSelect1)
      .subscribe(response => {
        if (response != null && response.ThamSo != null && response.ThamSo != "") {
          let data = JSON.parse(response.ThamSo); 
          //this.doituongSelect = data;

          this.doituongSelect.Id = data.Id;
          this.doituongSelect.SoCKCHDK = data.SoCKCHDK;
          this.doituongSelect.SoCKCHDTH = data.SoCKCHDTH;
          this.doituongSelect.PhatHanhSec = data.PhatHanhSec;
          this.doituongSelect.ThongTinBoSung = data.ThongTinBoSung;
          this.doituongSelect.NoTK1 = data.NoTK1;
          this.doituongSelect.CoTK1 = data.CoTK1;
          this.doituongSelect.NoTK2 = data.NoTK2;
          this.doituongSelect.CoTK2 = data.CoTK2;
          this.doituongSelect.NoTK3 = data.NoTK3;
          this.doituongSelect.CoTK3 = data.CoTK3;
          this.doituongSelect.MaDBHC = data.MaDBHC;
          this.doituongSelect.DonViId = data.DonViId;
          this.doituongSelect.NoiDungThanhToan = data.NoiDungThanhToan;
          this.doituongSelect.Tich_PhatHanhSec = data.Tich_PhatHanhSec;
          this.doituongSelect.Tich_ThongTinBoSung = data.Tich_ThongTinBoSung;
          this.doituongSelect.Tich_HienChiTietCacButToan = data.Tich_HienChiTietCacButToan;
          this.doituongSelect.Tich_TenTieuMucLaDienGiai = data.Tich_TenTieuMucLaDienGiai;
         


          
        }

        this.doituongSelect1.v_ma_ho_so = response.v_ma_ho_so;
        this.doituongSelect1.v_tieu_de = response.v_tieu_de;

      });



  }

  keyTenPress(event: any) {
    if (event.which === 13) {
      this.slCapTren.focus();
      event.preventDefault();
    }
  }
  public closeModal() {
    this.save.emit(null);
  }
  //public saveproduct() {

  //  this.repo.postRequest("api/doituong/addorupdate", this.doituongSelect)
  //    .subscribe(response => {
  //      console.log(response);
  //      this.doituongSelect.Id = response;
  //      this.save.emit(this.doituongSelect);
  //    });

  //}
  public tuychinhmaubaocao() {
    this.dtsuamaubaocao.loadDataInit("E7989F39-66D5-41BD-8547-3B346495B854");
    this.modaltuychinhmaubc.open();
  }
  public export(kieuin) {

    this.doituongSelect1.DoiTuong = JSON.stringify(this.doituongSelect);

    this.repo.postRequest("api/dvcapi/addorupdate_thamso", this.doituongSelect1)
      .subscribe(response => {
        // lưu tham số
      });


    $('#loading').show();
    let data = {
      Id: "E7989F39-66D5-41BD-8547-3B346495B854", // id cứng trong FunctionConstants để điều hướng đến hàm giay rút dự toán
      Type: kieuin,
      Data: JSON.stringify(this.doituongSelect)
    };
    if (kieuin === 'xlsx') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          $('#loading').hide();
          var file = new Blob([response.body], { type: 'vnd.ms-excel' });
          var fileURL = URL.createObjectURL(file);
          var a = document.createElement("a");
          a.href = fileURL;
          a.download = "giayrutdutoanc2-02a.xlsx";
          document.body.appendChild(a);
          a.click();

        });
    }
    if (kieuin === 'pdf') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          //console.log("tt");
          //console.log(response);
          if (response == "L") {
            $('#loading').hide();
            //this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
            //  data => {
            //    $('#loading').hide();
            //  },
            //  error => {
            //    this.msg = error;
            //  }
            //);
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "EPrescription");
          }

        });
    }
    


  }


  export_xml(loaiphieu) {
    //loaiphieu=1 giấy rút mẫu 02
    //loaiphieu=2 giấy rút mẫu 02b
    //loaiphieu=3 Bảng kê chứng từ thanh toán tạm ứng
    //loaiphieu=4 giấy đề nghị thanh toán tạm ứng
    this.doituongSelect1.DoiTuong = JSON.stringify(this.doituongSelect);
   
    $('#loading').show();
    let datatt = {
      Id: null,
      Type: null,
      Data: JSON.stringify({
        DonViId: this.currentUser.id_don_vi
        , UserName: this.currentUser.user_name
        , IdChungTu: this.doituongSelect.Id
        , LoaiPhieu: loaiphieu
        , Tich_HienChiTietCacButToan: this.doituongSelect.Tich_HienChiTietCacButToan
        , Tich_TenTieuMucLaDienGiai: this.doituongSelect.Tich_TenTieuMucLaDienGiai
        , DoiTuong: this.doituongSelect1.DoiTuong
      })
    };


    this.repo.postRequest("api/baocao/ketnoikbnn/", datatt)
      .subscribe(response => {
        $('#loading').hide();
        if (response.TrangThai = "OK") {
          location.href = "/Logs/Reports/" + response.DuongDan;
        }
        else
          swal('Cảnh báo!', response.TrangThai, 'warning');
      });



  }


  savedvc(doituong: any) {
    //this.modal_dvckbnn.dismiss();
  }
  kysodvc() {
    //if (this.selectedRows == null || this.selectedRows == "") {
    //  swal('Cảnh báo!', 'Chưa chọn chứng từ để in!.', 'warning');
    //  return;
    //}
    //let idchungtu = "";
    //this.selectedRows.forEach((item: any) => {
    //  idchungtu = item.Id;
    //  if (idchungtu != null)
    //    return true;
    //});
    //this.dtthamdvckbnnedit.loadDataInit(this.doituongSelect, this.currentUser.id_don_vi, 1);
    //this.modal_dvckbnn.open();
  }



}
